import { render } from "./TopMenu.vue?vue&type=template&id=c1f67a54&ts=true"
import script from "./TopMenu.vue?vue&type=script&lang=ts"
export * from "./TopMenu.vue?vue&type=script&lang=ts"

import "./TopMenu.vue?vue&type=style&index=0&id=c1f67a54&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__